export default __webpack_public_path__ + "static/media/cancelImg.ae214e73.svg";